module.exports = __webpack_public_path__ + "static/media/pricerite.f8e62e3f.png";